import ActivityItem from "./ActivityItem";

const ActivityLog = ({ logs = [] }) => (
  <div>
    <h2 className="text-text-primary text-sm font-semibold mb-4">Activity Log</h2>
    <div className="flex flex-col">
      {logs.length === 0 ? (
        <p className="text-text-muted text-sm py-2">No activity yet.</p>
      ) : (
        logs.map((log, index) => (
          <ActivityItem key={log.id} log={log} isLast={index === logs.length - 1} />
        ))
      )}
    </div>
  </div>
);

export default ActivityLog;